<template>
  <div class="rm-screen">
    <div v-if="!selectedCompanies.length" class="rm-empty">
      <v-icon size="40" color="#8a817a">mdi-domain</v-icon>
      {{ $t("no_companies_selected") }}
    </div>
    <div v-else-if="loading" class="rm-empty">
      <v-progress-circular indeterminate color="#c2410c"></v-progress-circular>
    </div>
    <div v-else-if="!sections.length" class="rm-empty">
      <v-icon v-if="!filters.search" size="40" color="#8a817a">mdi-pot-steam-outline</v-icon>
      {{ emptyTitle }}
    </div>

    <template v-else>
      <div class="rm-stats rm-stats--pair">
        <div class="rm-stat rm-stat--inverse">
          <span class="rm-stat__label">{{ $t("report_desktop.total_meals") }}</span>
          <span class="rm-stat__value rm-num">{{ totalFor("total") }}</span>
        </div>
        <div class="rm-stat">
          <span class="rm-stat__label">{{ $t("meals_main") }}</span>
          <span class="rm-stat__value rm-num">{{ rows.length }}</span>
        </div>
      </div>

      <section v-for="section in sections" :key="section.key" class="rm-card rm-mcard">
        <button
          type="button"
          class="rm-mcard__head"
          :aria-expanded="String(isOpen(section.key))"
          @click="toggle(section.key)"
        >
          <span class="rm-mcard__title">
            <span class="rm-mcard__name">{{ section.name }}</span>
            <span class="rm-muted">{{ pluralT("report_mobile.meals_n", section.total) }}</span>
          </span>
          <span class="rm-mcard__value rm-num">{{ section.total }}</span>
          <v-icon size="18" color="#8a817a" class="rm-mcard__chevron" :class="{ 'is-open': isOpen(section.key) }">
            mdi-chevron-down
          </v-icon>
        </button>

        <ul v-if="isOpen(section.key)" class="rm-list rm-mcard__list">
          <li v-for="row in section.rows" :key="row.num" class="rm-mrow">
            <div class="rm-mrow__main">
              <span class="rm-mrow__name">{{ row.label }}</span>
              <span class="rm-mrow__value rm-num">{{ row.total }}</span>
            </div>
            <div class="rm-mrow__shifts">
              <span v-for="shift in rowShifts(row)" :key="shift.id" class="rm-mrow__shift rm-num">
                <report-shift-tag :shift="shift.id"></report-shift-tag>
                {{ shift.quantity }}
              </span>
            </div>
          </li>
        </ul>
      </section>
    </template>
  </div>
</template>

<script>
import ReportMealsTabDishes from "@/components/report/more-restaurants/tabs/ReportMealsTabDishes.vue";
import hasPlural from "../../../shared/hasPlural";
import hasShiftBinding from "../../../shared/hasShiftBinding";
import hasShiftSubtitle from "../../../shared/hasShiftSubtitle";
import hasMoreDishSections from "../../../shared/more/hasMoreDishSections";
import ReportShiftTag from "../../../shared/ReportShiftTag.vue";
import "../reportMobileMealCards.scss";

/**
 * Mobilni "Jela" (firme koje hrani restoran): šta kuhinja sprema, po grupi jela (grupe se sklapaju), sa brojem po
 * smeni. Firme, smene i period su u zaglavlju, pretraga u lupi. Nasleđuje učitavanje, štampu i Excel iz starog taba.
 */
export default {
  name: "MoreMobileDishes",
  extends: ReportMealsTabDishes,
  mixins: [hasPlural, hasShiftBinding, hasShiftSubtitle, hasMoreDishSections],
  components: { ReportShiftTag },
  methods: {
    /** Grupa je otvorena dok je nije sklopio korisnik; u pretrazi su sve otvorene da se nalazi vide. */
    isOpen(key) {
      return Boolean(this.filters.search) || !this.collapsed[key];
    },
    rowShifts(row) {
      return this.activeShifts.map((shift) => ({ id: shift.id, quantity: row[shift.key] || 0 })).filter((shift) => shift.quantity > 0);
    },
  },
};
</script>
